import React, { useEffect } from 'react';

export default function ContactPage() {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'Contact — WeSonder';
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', 'Contact WeSonder — questions, support, and media inquiries.');
    }
  }, []);

  return (
    <div className="bg-white">
      <header className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl font-bold text-slate-900">Contact</h1>
          <p className="mt-2 text-slate-600">We typically respond within 1–2 business days.</p>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Email</h2>
          <p className="mt-2 text-slate-700">
            <a href="mailto:support@wesonder.io" className="text-blue-600 hover:text-blue-700">support@wesonder.io</a>
          </p>
          <p className="mt-1 text-slate-700">
            <a href="mailto:james@wesonder.io" className="text-blue-600 hover:text-blue-700">james@wesonder.io</a>
          </p>
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Company</h2>
          <p className="mt-2 text-slate-700">WeSonder, Inc.</p>
        </div>
      </div>
    </div>
  );
}


